export default __webpack_public_path__ + "static/media/enrichir.2ebfa9aa.png";